import {
  faCheckCircle,
  faCircleExclamation,
  faClock,
  faPauseCircle,
  faTimesCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./statusCell.scss";

const IconMappings = {
  INACTIVE: faPauseCircle,
  ACTIVE: faCheckCircle,
  FAILED: faTimesCircle,
  PENDING: faClock,
  INCOMPLETE: faCircleExclamation,
};

export type Status = keyof typeof IconMappings;
const StatusCell: React.FC<{ status: string }> = ({ status }) => {
  const icon = IconMappings[status.toUpperCase() as Status];
  return (
    <div className="integration-status">
      <FontAwesomeIcon icon={icon} />
      <span className="label">{status}</span>
    </div>
  );
};

export default StatusCell;
